<div>
  <div class="col-sm-12 header">
    <h4 *ngIf="data.tab!='Received'">
      Ressign Lead
    </h4>
    <h4 *ngIf="data.tab=='Received'"> Assign Lead </h4>
  </div>
  <div class="form-group mb-0" [formGroup]="reassignForm">
    <label>Select ADE*</label>
    <!-- <mat-form-field class="block-input">
      <mat-select placeholder="ADE*" formControlName="userid" (selectionChange)="onUserSelect($event.value)">
        <mat-option *ngFor="let ade of adeList" [value]="ade.userid">
          {{ ade.userid}} {{ade.name}}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    <ng-select [items]="adeList" (change)="onUserSelect($event)" bindLabel="userid" bindValue="userid"
      dropdownPosition="bottom" [searchFn]="customSearchFn" formControlName="userid" [hideSelected]='true'
      [searchable]="true" #selectOwner required>
      <ng-template ng-option-tmp let-item="item">
        <div title="{{item.userid}}">{{item.userid}}</div>
      </ng-template>
    </ng-select>
  </div>
  <div class="wrapper">
    <button type="button" class="cancel-action margin" (click)="closeDialog()"> Cancel </button>
    <button type="button" class="create-action margin" [disabled]="!reassignForm.valid" (click)="ReassignLead()">
      Confirm </button>
  </div>
</div>